import { NgModule } from '@angular/core';

//******************************************************************************
//  Import Core Components
//******************************************************************************
import { CoreImports } from '~/core/classes/imports/core.imports';

//******************************************************************************
//  Import External Components
//******************************************************************************
import { ExternalImports } from '~/classes/imports/external.imports';

//******************************************************************************
//  Services
//******************************************************************************
import { ApiService } from '~/services/api.service';
import { AppStateService } from '~/services/app-state.service';

//******************************************************************************
//  Pages
//******************************************************************************
import { HomeComponent } from '~/pages/home/home.component';
import { DashboardComponent } from '~/pages/dashboard/dashboard.component';

//******************************************************************************
//  App Components (Standalone)
//******************************************************************************
import { ChatComponent } from '~/components/chat/chat.component';
import { CampaignFormComponent } from '~/components/campaign-form/campaign-form.component';
import { ConversationSidebarComponent } from '~/components/conversation-sidebar/conversation-sidebar.component';
import { AudienceDialogComponent } from '~/components/audience-dialog/audience-dialog.component';
import { MultiSelectDropdownComponent } from '~/components/multi-select-dropdown/multi-select-dropdown.component';
import { PeoplePickerComponent } from '~/components/people-picker/people-picker.component';
import { SettingsComponent } from '~/components/settings/settings.component';

//******************************************************************************
//  Pipes
//******************************************************************************
import { SafePipe } from '~/core/pipes/safe.pipe';

const components: any[] = [
    HomeComponent,
    DashboardComponent,
];

const standaloneComponents: any[] = [
    ChatComponent,
    CampaignFormComponent,
    ConversationSidebarComponent,
    AudienceDialogComponent,
    MultiSelectDropdownComponent,
    PeoplePickerComponent,
    SettingsComponent,
];

const services: any[] = [
    ApiService,
    AppStateService,
];

@NgModule({
    imports: [
        CoreImports,
        ExternalImports,
        ...standaloneComponents,
    ],
    declarations: [
        ...components,
        SafePipe,
    ],
    exports: [
        ...components,
        ...standaloneComponents,
    ],
    providers: [
        ...services,
    ],
})

export class AppImports { }
